import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { Treatment } from "src/app/core/model/v2/practitioner/treatment";
import { concat, Observable, of, Subject } from 'rxjs';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PractitionerTreatment } from '../../../core/model/v2/practitioner/practitionerTreatment';
import { MatSnackBar } from '@angular/material';
import { Treatmentlocation } from '../../../core/model/v2/practitioner/treatmentlocation';
import { Treatmentlocationrequest } from '../../../core/model/v2/practitioner/treatmentlocationrequest';
import { PractitionerTreatmentLocationrequest } from '../../../core/model/v2/practitioner/practitioner-treatment-locationrequest';
import { WorkingHours } from '../../../core/model/v2/workinghours';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { CodeTable } from 'src/app/core/model/v2/code-table';
import { Treatmenttype } from '../../../core/model/v2/practitioner/treatmenttype';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../../../core/services/v2/utils.service';

interface Days {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-shared-treatment',
  templateUrl: './shared-treatment.component.html',
  styleUrls: ['./shared-treatment.component.scss']
})
export class SharedTreatmentComponent implements OnInit {
  editTreatmentForm: FormGroup;
  //@Output() refreshTreatment = new EventEmitter();
  practitionerId: number;
  //@Output() refreshTreatment = new EventEmitter();
  @Output() refreshTreatment: EventEmitter<number> = new EventEmitter<number>();
  filteredAffiliations: Observable<Treatment[]>;
  isAddTreatment: boolean = false;
  randomAddress: String = '123 Main St., Kingwood, TX 77339';
  indexer: number;
  @Input() SymptomData: Practitioner = new Practitioner();
  treatmentLocation: Treatmentlocation[] = [];
  objtreatmentLocation: Treatmentlocation;
  practitionerTreatment: PractitionerTreatment;
  treatmentLocationRequest: PractitionerTreatmentLocationrequest;
  arrTrequest: Treatmentlocationrequest[] = [];
  tRequest: Treatmentlocationrequest;
  treatmentCtrl = new FormControl();
  selectedTreatments: Treatment[] = <any>[];
  treatmentLoading = false;
  affilicationCtrl = new FormControl('');
  treatmentInput$ = new Subject<string>();
  searchResultTreatments: Observable<Treatment[]>;

  treatmentid: number;
  newTreatmentid: number;
  locationid: number;
  newLocationid: number;
  selected = false;
  id: number;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  eduObj: Practitioner;
  treatmentWrkngHrs: WorkingHours[] = [];
  treatmentTypes: string[] = [];
  arrTreatmentObj: Treatmenttype[] = [];
  treatmentType: CodeTable = {} as CodeTable;
  commaDelimitedTTypes: string;
  @Input() isFromProfileLayout;
  @Input() PractitionerTreatLists;
  Alltreatment: string[] = [];
  //AlltreatmenTypes = [];
  treatmentSum = [];
  patientId: number;
  days: Days[] = [
    { value: '0', viewValue: 'Monday' },
    { value: '1', viewValue: 'Tuesday' },
    { value: '2', viewValue: 'Wednesday' },
    { value: '3', viewValue: 'Thursday' },
    { value: '4', viewValue: 'Friday' },
    { value: '5', viewValue: 'Saturday' },
  ];
  newWorkingHours: WorkingHours[];
  workinghour: WorkingHours[];
  constructor(private _practiceService: PracticeService,
    private fb: FormBuilder,
    private _loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private utils: UtilsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {

    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((val) => {
        return this._filterAffilications(val || "");
      })
    );
  }

  ngOnInit() {
    this.getParams();
    if (this.patientId > 0) {
      this.isFromProfileLayout = false;
    }

    this.loadtreatment();
    this.commonService.GetItemsByCodeNamesWithoutCache(['TREATMENTTYPE']).subscribe(
      codeTables => {
        this.treatmentType = codeTables.codeTable[0];

      },
      error => console.log(error)
    );
  }
  getParams() {
    //this.route.events.subscribe((e) => {
    //  if (e instanceof NavigationEnd) {
    //    console.log(e.url);
    //  }
    //});

    let decodedURI = decodeURIComponent(window.location.href);
    if ((window.location.href.indexOf("%")) > -1) {
      this.getEncodedUrlParams(decodedURI);
    }
    else {
      this.route.params.subscribe(
        (params) => {
          this.id = +params["id"];
          this.patientId = params["patientId"];
          // this.hsid = params["hsid"]
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }
  getEncodedUrlParams(encodedUrl) {
    let decodedURI = decodeURIComponent(window.location.href);
    let backSlashIndex = decodedURI.lastIndexOf("/");
    let paramStr = decodedURI.substring(backSlashIndex);
    let arrparams = paramStr.split(";");
    arrparams.forEach(x => {
      if (x.indexOf("=") > -1) {
        if (x.indexOf("hsid") == -1 && x.indexOf("id") > -1) {
          this.id = Number(x.split("=")[1]);
        }
      }

    });
  }
  async ngOnChanges() {
    this.getParams();

    if (this.patientId > 0) {
      this.isFromProfileLayout = false;
    }
    this.PractitionerTreatLists;
    this.isFromProfileLayout;
    this.Alltreatment[0] = "";
    let counter: number = 0;
    let ptt: any[] = [];
    if (this.PractitionerTreatLists && this.PractitionerTreatLists != undefined && this.PractitionerTreatLists.length > 0) {
      for (let i = 0; i < this.PractitionerTreatLists.length; i++) {
        this.PractitionerTreatLists[i].treatmentType.practitionerTreatments.forEach((x, k) => {

          if (x.treatment.name != "") {
            this.Alltreatment[i] = (this.Alltreatment[i] != undefined ? this.Alltreatment[i] + x.treatment.name : x.treatment.name) + "/";
          }

          //let treatmentTypeObj = JSON.parse(x.treatmentType); // string to "any" object first
          //let arrT = treatmentTypeObj as string[];
          // this.AlltreatmenTypes[counter] = arrT;
          counter = counter + 1;
          if (k == this.PractitionerTreatLists[i].treatmentType.practitionerTreatments.length - 1) {
            this.Alltreatment[i] = this.Alltreatment[i].lastIndexOf("/") != -1 ? this.Alltreatment[i].slice(0, -1) : this.Alltreatment[i];
          }
        })

        let pTreatmentType: any[] = [];

        if (this.Alltreatment[i] != undefined && this.Alltreatment[i] != "") {
          this.treatmentSum.push({ allTreatment: this.Alltreatment[i] });

        }
        //this.AlltreatmenTypes = [];
        counter = 0;
      }
      console.log(JSON.stringify(this.treatmentSum));
    }
    else {
      this.treatmentSum = this.SymptomData.practitionerTreatments;
    }

    if (this.SymptomData && this.SymptomData != undefined) {
      await this.GetPractitionerTreatments(this.SymptomData.id);
      this.treatmentSum = this.isFromProfileLayout == false ? [] : this.treatmentSum;

      if (this.SymptomData && this.SymptomData != undefined && this.SymptomData.practitionerTreatments != undefined) {
        this.SymptomData.practitionerTreatments.forEach((x) => {
          if (this.isFromProfileLayout == false) {
            if (x.treatment.name != undefined && x.treatment.name != "") {
              //this.treatmentSum.push(x.treatment.name);
              this.treatmentSum.push({ allTreatment: x.treatment.name });
            }
          }

          if (x.treatmentType != null) {
            let treatmentTypeObj = JSON.parse(x.treatmentType); // string to "any" object first
            let arrT = treatmentTypeObj as string[];
            let pCommaDelimited = "";
            arrT.forEach((y) => {
              pCommaDelimited = pCommaDelimited + y + ","

            })
            x.treatmentTypeCommaSeperated = pCommaDelimited.lastIndexOf(",") != -1 ? pCommaDelimited.slice(0, -1) : pCommaDelimited;
          }
        })
        this.changeDetectorRef.detectChanges();
      }
    }
  }
  get workingHours() {
    return this.editTreatmentForm.get("workingHours") as FormArray;
  }
  setTime(i) {
    let workingHrsArr = this.getWorkingHoursDetails();
    workingHrsArr.removeAt(i);
  }
  addNewDay() {

    let workingHrsArr = this.editTreatmentForm.get('workingHours') as FormArray;
    let newWorkingHrsEntry = this.fb.group({
      day: '',
      timeFrom: '',
      timeTo: ''
    })
    workingHrsArr.push(newWorkingHrsEntry);



    // this.SymptomData.healthSystems[this.indexer].workingHours.push({ day: '', hours: [""] });
    // this.editLocation(this.indexer);
  }
  getWorkingHoursDetails(): FormArray {
    return this.editTreatmentForm.get('workingHours') as FormArray;
  }
  //getTreatmentTypeDetails(): FormArray {
  //  return this.editTreatmentForm.get('treatmentTypeDetail') as FormArray;
  //}

  searchTreatment(term: string = null): Observable<Treatment[]> {
    return this._practiceService.getTreatmentsByName(term);
  }
  trackByFn(item: Treatment) {
    return item.id;
  }
  loadtreatment() {
    this.searchResultTreatments = concat(
      of([]), // default items
      this.treatmentInput$.pipe(
        takeUntil(this.ngUnsubscribe),
        filter((data) => data.trim().length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        //tap(() => (this.treatmentLoading = true)),
        switchMap((term) =>
          this._practiceService.getTreatmentsByName(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.treatmentLoading = false))
          )
        )
      )
    );
  }

  onSelectTreatment(treatment: Treatment): void {
    //console.log(treatment);
    if (!treatment.id) {
      this._practiceService.addnewTreatment(treatment.name).subscribe(
        (trt) => {
          this._loaderService.hide();
          if (trt) {
            if (trt.resultStatus.isSuccess) {
              //console.log(trt.result);
              treatment = trt.result;
              if (treatment.id) {
                const practitionerTreatment = new PractitionerTreatment();
                practitionerTreatment.practitioner = this.SymptomData;
                practitionerTreatment.practitionerId = this.SymptomData.id;
                practitionerTreatment.treatment = treatment;
                practitionerTreatment.treatmentId = treatment.id;
                if (
                  this.SymptomData.practitionerTreatments.find(
                    (x) => x.treatment.name == treatment.name
                  ) == null
                ) {
                  this.SymptomData.practitionerTreatments.push(
                    practitionerTreatment
                  );
                } else {
                  // this._snackBar.open(
                  //   `Already existed to ${this.practitionerData.fullName}.`,
                  //   "Ok"
                  // );
                  this._loaderService.hide();
                }
              }
              //this.onSelectTreatment(trt.result);
            }
            //this.treatmentsOptions = symp;
          }
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
          return null;
        }
      );
    }
    if (treatment.id) {
      //console.log(treatment);
      const practitionerTreatment = new PractitionerTreatment();
      practitionerTreatment.practitioner = this.SymptomData;
      practitionerTreatment.practitionerId = this.SymptomData.id;
      practitionerTreatment.treatment = treatment;
      practitionerTreatment.treatmentId = treatment.id;
      if (
        this.SymptomData.practitionerTreatments.find(
          (x) => x.treatment.name == treatment.name
        ) == null
      ) {
        this.SymptomData.practitionerTreatments.push(
          practitionerTreatment
        );
      } else {
        this._snackBar.open(
          `Already existed to ${this.SymptomData.fullName}.`,
          "Ok"
        );
        this._loaderService.hide();
      }
    }
  }

  formbuilding() {
    this.affilicationCtrl.setValue('');
    this.editTreatmentForm = this.fb.group(
      {
        //treatmentFormControl: new FormControl(),
        locationFormControl: new FormControl(''),
        treatmentTypeDetail: new FormArray([
          this.fb.group({
            treatmentTypeFormControl: new FormControl('')
          })
        ]),
        workingHours: new FormArray([
          this.fb.group({
            day: new FormControl(''),
            timeFrom: new FormControl(''),
            timeTo: new FormControl('')
          })
        ])
      });
  }

  addTreatment() {
    this.indexer = undefined;
    this.newTreatmentid = undefined;
    this.formbuilding();
    this.isAddTreatment = true;

  }
  removeTreatment(i: number) {

  }

  deletePractitionerTreatment(treatmentId): void {
    this._loaderService.show();

    this._practiceService.deletePractitionerTreatment(treatmentId).subscribe(
      (_) => {
        this.SymptomData.practitionerTreatments = this.SymptomData.practitionerTreatments.filter(i => i.id != treatmentId);
        this.changeDetectorRef.detectChanges();
        this._loaderService.hide();

      },
      (error) => { console.error(error); this._loaderService.hide(); },
      () => { this._loaderService.hide(); });
  }


  //addTreatmentType() {

  //  let treatmentTypeArr = this.editTreatmentForm.get('treatmentTypeDetail') as FormArray;
  //  let newTreatmentTypeEntry = this.fb.group({
  //    treatmentTypeFormControl: ''
  //  })
  //  treatmentTypeArr.push(newTreatmentTypeEntry);
  //  this.isAddTreatment = true;
  //}
  //removeTreatmentType(i: number) {
  //  let treatmentTypeArr = this.getTreatmentTypeDetails();
  //  treatmentTypeArr.removeAt(i);
  //}
  backTotreatment() {
    this.isAddTreatment = false;
    this.treatmentid = this.SymptomData.practitionerTreatments[this.indexer].id;
  }
  editTreatmnt(i) {
    let arrTreatmentTypeDetailsControlsGroup = [];

    this.indexer = i;
    this.treatmentid = this.SymptomData.practitionerTreatments[this.indexer].treatmentId;
    this.locationid = this.SymptomData.practitionerTreatments[this.indexer].locationId;
    this.affilicationCtrl.setValue(this.SymptomData ? this.SymptomData.practitionerTreatments[i].treatment.name : "");
    const operationHoursStr = this.SymptomData.practitionerTreatments[this.indexer].operationHours;
    let workingHrs = [];
    if (operationHoursStr && typeof operationHoursStr === 'string') {
      workingHrs = JSON.parse(operationHoursStr);
    }

    //if (this.SymptomData.practitionerTreatments[this.indexer] != null) {
    //  let treatmentTypeObj = JSON.parse(this.SymptomData.practitionerTreatments[this.indexer].treatmentType); // string to "any" object first
    //  this.treatmentTypes = treatmentTypeObj as string[];
    //}
    //if (this.treatmentTypes != undefined && this.treatmentTypes.length > 0) {
    //  const treatmentGroups = this.treatmentTypes.map(x => this.fb.group({
    //    treatmentTypeFormControl: this.fb.control(x)
    //  }));
    //  treatmentGroups.forEach((x) => {
    //    arrTreatmentTypeDetailsControlsGroup.push(x);
    //  })
    //}

    this.editTreatmentForm = this.fb.group(
      {
        //treatmentFormControl: new FormControl(
        //  this.SymptomData
        //    ? this.SymptomData.practitionerTreatments[i].treatment.name : null
        //),
        locationFormControl: new FormControl(
          this.SymptomData
            ? (this.SymptomData.healthSystems.find(x => x.location.id == this.SymptomData.practitionerTreatments[i].locationId) ? this.SymptomData.healthSystems.find(x => x.location.id == this.SymptomData.practitionerTreatments[i].locationId).name : "") : null
        ),
        //treatmentTypeDetail: arrTreatmentTypeDetailsControlsGroup.length > 0 ? new FormArray(arrTreatmentTypeDetailsControlsGroup) :
        //  new FormArray([
        //    this.fb.group({
        //      treatmentTypeFormControl: new FormControl('')
        //    })
        //  ]),

        workingHours: this.fb.array(
          workingHrs
            ? workingHrs.map((workings) => {
              return this.fb.group({
                day: workings.Day,
                timeFrom:
                  workings.Hours && workings.Hours[0] != ""
                    ? workings.Hours[0].split("-")[0].trim()
                    : "",
                timeTo:
                  workings.Hours && workings.Hours[0] != ""
                    ? workings.Hours[0].split("-")[1].trim()
                    : "",
                isClosed: workings.Hours && workings.Hours[0] == "" ? false : false,
              });
            })
            : null
        ),
      });
    this.isAddTreatment = true;
  }
  async OnTreatmentSubmit(editPForm: FormGroup) {
    if (this.editTreatmentForm != undefined) {
      if (this.affilicationCtrl.value == undefined || this.affilicationCtrl.value == "") {
        this._snackBar.open("Please select a treatment!", "Ok", {
          duration: 5000
        });
        return false;
      }
    }
    if (this.editTreatmentForm != undefined) {
      if (this.editTreatmentForm.value.locationFormControl == undefined || this.editTreatmentForm.value.locationFormControl == "") {
        this._snackBar.open("Please select a location!", "Ok", {
          duration: 5000
        });
        return false;
      }
    }
    await this.getTreatmentIdByName(this.affilicationCtrl.value);
    let locationId = this.SymptomData.healthSystems.find(x => x.name == this.editTreatmentForm.value.locationFormControl).location.id;
    // let treatmentTypeValue = this.editTreatmentForm.value.treatmentTypeFormControl;
    this.workinghour = this.editTreatmentForm.value.workingHours.map((wh) => {
      return {
        day: wh.day,
        hours: [wh.isClosed ? "" : wh.timeFrom + "-" + wh.timeTo],
      };
    });
    this.workinghour = this.workinghour.filter(x => x.day != undefined);
    if (this.indexer == undefined) {
      this.tRequest = new Treatmentlocationrequest();
      this.tRequest.treatmentId = this.newTreatmentid == undefined ? this.SymptomData.practitionerTreatments[this.indexer].treatment.id : this.newTreatmentid;
      this.tRequest.locationId = locationId;
      this.tRequest.workingHours = this.workinghour;
      //this.tRequest.treatmentType = this.treatmentTypes;
      this.treatmentLocationRequest.treatmentLocations.push(this.tRequest);
    }
    else {
      let oTid = this.SymptomData.practitionerTreatments[this.indexer].treatment.id;
      let oldLid = this.SymptomData.practitionerTreatments[this.indexer].locationId;
      let tObj = this.treatmentLocationRequest.treatmentLocations.find(x => x.treatmentId == oTid);
      let tIndex = this.treatmentLocationRequest.treatmentLocations.indexOf(tObj);
      this.treatmentLocationRequest.treatmentLocations[tIndex].locationId = locationId;
      this.treatmentLocationRequest.treatmentLocations[tIndex].treatmentId = this.newTreatmentid != undefined ? this.newTreatmentid : this.treatmentid;
      this.treatmentLocationRequest.treatmentLocations[tIndex].workingHours = this.workinghour;
      //this.treatmentLocationRequest.treatmentLocations[tIndex].treatmentType = this.treatmentTypes;
    }
    this.treatmentLocationRequest.practitionerId = this.SymptomData.id;
    this._loaderService.show();
    this._practiceService.addOrUpdateTreatmentsLocation(this.treatmentLocationRequest).subscribe(
      (res) => {
        this.utils.showMessageSnackBar(`Treatment added to ${this.SymptomData.fullName}.`);
        this.refreshTreatment.emit(this.SymptomData.id);
        this._loaderService.hide();
        this.isAddTreatment = false;
        this.changeDetectorRef.detectChanges();
        //this.ngOnChanges()
        // window.location.reload();
        // this.GetTreatmentData();
      },
      (error) => { console.error(error); this._loaderService.hide(); },
    )
  }

  async GetPractitionerTreatments(practitionerId) {
    this._loaderService.show();
    await this._practiceService.getPractitionerTreatmentsWithLocation(practitionerId).subscribe(
      (trt) => {

        this.treatmentLocationRequest = trt;
        if (this.treatmentLocationRequest != undefined && this.treatmentLocationRequest.treatmentLocations.length > 0 && this.treatmentLocationRequest.treatmentLocations != undefined) {

          this.treatmentWrkngHrs = this.treatmentLocationRequest.treatmentLocations[0].workingHours != null ? this.treatmentLocationRequest.treatmentLocations[0].workingHours : [];
        }
        this._loaderService.hide();
      },
      (error) => { console.error(error); this._loaderService.hide(); },
    );
  }

  _filterAffilications(value: string): Observable<any[]> {
    if (value.length >= 2) {
      return this._practiceService.getTreatmentsByName(value).pipe(
        map((a) =>
          a.filter((option) => {
            var v1 = option.name ? option.name.toLowerCase().startsWith(value.toLowerCase()) : (option.code ? option.code.toLowerCase() : option.code).startsWith(value.toLowerCase());
            option.name ? option.name.toLowerCase().indexOf(value.toLowerCase()) === 0 : (option.code ? option.code.toLowerCase() : option.code).indexOf(value.toLowerCase()) === 0;
            return v1;
          })
        )
      );
    }
  }

  optionClicked(event: Event, affiliation: Treatment) {
    event.stopPropagation();
    const self = this;
    self.selected = true;
    this.newTreatmentid = affiliation.id;

  }
  getTIndexNumber(globalTreatment: PractitionerTreatmentLocationrequest, selectedTid: number) {
    let indexT = 0
    let tObj = globalTreatment.treatmentLocations.find((x) => x.treatmentId == selectedTid);
    if (tObj != undefined && tObj != null) {
      indexT = globalTreatment.treatmentLocations.indexOf(tObj, 0);
    }
    return indexT;
  }

  async getTreatmentIdByName(treatmentName: string) {

    this._loaderService.show();
    await this._practiceService.getTreatmentsByName(treatmentName).subscribe(
      (trt) => {

        this.treatmentid = trt.find(x => x.name == treatmentName).id;
        this._loaderService.hide();
      },
      (error) => { console.error(error); this._loaderService.hide(); },
    );
  }
  toggleCard(index: number) {
    let data = this.SymptomData.practitionerTreatments;
    this.SymptomData.practitionerTreatments[index].showData = !data[index].showData;
    //this.pastHealthHistoryObj = data;
  }

  GetTreatmentData() {
    let self = this;
    self._loaderService.show();
    self._practiceService.getPractitionerDetails(this.SymptomData.id).subscribe(
      (practitionerData) => {

        self.SymptomData = practitionerData;

      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      },
      () => {
        self._loaderService.hide();
      }
    );
  }
  toggleCard1(j: number) {

    let data = this.treatmentSum;
    this.treatmentSum[j].showData = !data[j].showData;
  }
  checkDays(i, dayName?: string) {

    let count: number = 0;
    let workingHrsArr = this.getWorkingHoursDetails();

    workingHrsArr.controls.filter((x) => x.value.day == (dayName != undefined ? dayName : workingHrsArr.controls[i].value.day)).forEach(element => {
      count++;
    });

    if (count > 1) {
      this.utils.showMessageSnackBar("Duplicate day selected!", true);
      return false;
    }
    else {
      return true;
    }
  }

}
